import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BackdropComponent } from '@components/shared/backdrop/backdrop.component';
import { BackdropService } from '@components/shared/backdrop/backdrop.service';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

@Component({
    selector: 'app-cart-empty',
    standalone: true,
    imports: [TranslatePipe],
    templateUrl: './cart-empty.component.html',
    styleUrl: './cart-empty.component.scss'
})
export class CartEmptyComponent {

    private router = inject(Router);
    private backdropService = inject(BackdropService);

    goToHome() {
        this.backdropService.hide();
        this.router.navigate(['/']);
    }

    goToProducts() {
        this.router.navigate(['/prodotti']);
    }
}